import type { AxiosClient } from './utils/client/axios';
import { ApiLayer } from './utils/api-layer';
import { axiosApp } from './utils/client/axios';

type ExcludeType = 'contacts' | 'members' | 'resources';

type SearchParams = {
  page?: number | null;
  count?: number | null;
  q?: string | null;
  exclude?: ExcludeType[];
};

class SearchLayer extends ApiLayer<AxiosClient> {
  searchContacts(params: SearchParams = {}) {
    return this.methods.get('/search/contacts', { params });
  }
}

export const SearchAPI = new SearchLayer(axiosApp);
